import $ from "jquery";
import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/Cues/CueHistoryStore';
import { toFormattedDatetime } from '../../tools/toolkit';
import { LoadingBar } from "../Controls/LoadingBar";
import ModalDialogError from '../Controls/ModalDialogError';
import { isHtmlLink } from "../../tools/validator";

var programmeId;
var cueId;

class CueHistory extends React.Component {

    constructor(props) {
        super(props);

        // This binding is necessary to make "this" work in the callback
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        programmeId = this.props.match.params['programmeId'];
        cueId = this.props.match.params['cueId'];

        if (programmeId && cueId) {
            this.props.getCueHistory(programmeId, cueId);
        }
        else {
            this.props.getCueHistory();
        }
    }

    handleErrorDialogClose = () => {
        this.props.clearErrorMessage();
    }

    // This will handle Cancel button click event.
    handleCancel(event) {
        event.preventDefault();
        this.props.history.push("/DeletedCues/" + programmeId);
    }

    render() {
        return (
            <div className='card mt-3'>
                <div className='container-fluid p-4'>
                    <div className='row'>
                        <h3>Cue History</h3>
                    </div>
                    <div className='row publicationLogContent'>
                        {(this.props.isLoading ? '' : this.renderListTable())}
                    </div>
                    <div className='row'>
                        <div className='col-md-10'>
                        </div>
                        <div className='col-md-2 p-1'>
                            <input id='cancelButton' className='btn btn-outline-secondary btn-block' type='button' value='Cancel' onClick={this.handleCancel} />
                        </div>
                    </div>
                </div>
                <ModalDialogError id='errorModalDialog' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                <LoadingBar isLoading={this.props.isLoading} />
            </div>
        );
    }

    renderListTable() {
        return (
            <table className='table'>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Title</th>
                        <th>Status</th>
                        <th>Composer</th>
                        <th>Publisher</th>
                        <th>Arranger</th>
                        <th>Performer</th>
                        <th>Record/Video Label</th>
                        <th>Music Origin</th>
                        <th>Cat. No.</th>
                        <th>ISRC</th>
                        <th>Use</th>
                        <th>User</th>
                        <th>Time</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.lists.map(item =>
                        <tr key={item.id}>
                            <td>{item.position}</td>
                            <td>{this.renderIdentifier(item.track.title)}</td>
                            <td>{item.licenceStatus.name}</td>
                            <td>{this.renderIdentifier(item.track.interestedParties.filter(x => x.role === 'CP')[0].name)}</td>
                            <td>{this.renderIdentifier(item.track.interestedParties.filter(x => x.role === 'PL')[0].name)}</td>
                            <td>{this.renderIdentifier(item.track.interestedParties.filter(x => x.role === 'AR')[0].name)}</td>
                            <td>{this.renderIdentifier(item.track.interestedParties.filter(x => x.role === 'AT')[0].name)}</td>
                            <td>{this.renderIdentifier(item.track.product.recordOrVideoLabel.name)}</td>
                            <td>{item.track.musicOrigin.name}</td>
                            <td>{item.track.product.catalogueNumber}</td>
                            <td>{item.track.isrc}</td>
                            <td>{item.usage.name}</td>
                            <td>{item.deletedBy}</td>
                            <td>{toFormattedDatetime(item.datetimeDeleted)}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    renderIdentifier(identifier) {
        let isLink = isHtmlLink(identifier);
        let shortIdentifier = identifier.length > 70 ? identifier.substring(0, 70) + '...' : identifier;

        if (isLink) {
            return (
                <NavLink data-toggle='tooltip' data-placement='bottom' title={identifier}
                    to={identifier.toLowerCase().lastIndexOf('www', 0) === 0 ? 'http://' + identifier : identifier} target='_blank' >
                    {shortIdentifier}
                </NavLink>
            );
        }
        return (
            <span data-toggle='tooltip' data-placement='bottom' title={identifier}>{shortIdentifier}</span>
        );
    }
}

export default connect(
    state => state.cueHistory,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CueHistory);


// WEBPACK FOOTER //
// ./src/components/Cues/CueHistory.js